import React__default from 'react';

var FocusRestoreContext = /*#__PURE__*/React__default.createContext(undefined);

export { FocusRestoreContext };
